import React from "react";
import "./style.css";

function Footer (props) {
  return <div className="foot">{props.children}</div>;
}

export default Footer;